import { Box, Divider, Grid, List, ListItem, ListItemButton, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import AccessibilityOptions from './AccessibilityOptions';
import routes from '../data/Navigation';

export default function Footer() {
  return (
    <>
      <Box
        component='footer'
        sx={{
          backgroundColor: '#0B2545',
          color: '#E2E8F0',
          borderRadius: { xs: 2, md: 4 },
          padding: { xs: '32px 20px', md: '48px 36px' },
          marginTop: '60px',
          border: '1px solid rgba(0, 180, 216, 0.25)',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2)',
        }}
      >
        <Grid
          container
          spacing={4}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Typography
              variant='h6'
              component='h2'
              sx={{ color: '#FFFFFF', mb: 1.5, fontWeight: 700 }}
            >
              Scaled Tech Consulting
            </Typography>
            <Typography
              variant='body2'
              sx={{ color: '#CBD5E1', mb: 2 }}
            >
              Custom applications, content platforms, and connected workflows.
            </Typography>
            <Typography
              variant='body2'
              sx={{ color: '#CBD5E1', mb: 2 }}
            >
              Working with clients across Canada and the United States, remotely.
            </Typography>
            <Typography
              variant='body2'
              sx={{ color: '#CBD5E1' }}
            >
              Report an accessibility barrier:{' '}
              <Box
                component='a'
                href='mailto:info@scaledtech.consulting?subject=Website%20accessibility'
                aria-label='Email info@scaledtech.consulting about accessibility'
                sx={{ color: '#FFFFFF', overflowWrap: 'anywhere' }}
              >
                info@scaledtech.consulting
              </Box>
            </Typography>
            <AccessibilityOptions inverted />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Typography
              variant='subtitle2'
              component='h3'
              sx={{ color: '#FFFFFF', mb: 1.5 }}
            >
              Navigation
            </Typography>
            <List disablePadding>
              {routes
                .filter((route) => route.footer && route.listInFooter !== false)
                .map((route) => (
                  <ListItem
                    key={route.path}
                    disablePadding
                  >
                    <ListItemButton
                      component={Link}
                      to={route.path}
                      sx={{ px: 1, py: 0.5, color: '#CBD5E1' }}
                    >
                      {route.label1} {route.label2}
                    </ListItemButton>
                  </ListItem>
                ))}
            </List>
          </Grid>
        </Grid>
        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)', my: 3 }} />
        <Typography
          variant='body2'
          sx={{ color: '#CBD5E1' }}
          // The build year is in the prerendered HTML; a visit in a later year renders the new one.
          suppressHydrationWarning
        >
          © {new Date().getFullYear()} Scaled Tech Consulting. All rights reserved.
        </Typography>
      </Box>
    </>
  );
}
